import React, { useEffect } from "react";
import { useAdminOrderStore } from "../../../hooks/admin/order";
import orderinsiteuser from "src/assets/images/order-insite-user.svg";
import orderinsitebilling from "src/assets/images/order-insite-billing.svg";
import orderinsiteshipping from "src/assets/images/order-insite-shipping.svg";
import orderinsiteshippingmethod from "src/assets/images/order-insite-shipping-method.svg";
import companyIcon from "src/assets/images/company-icon.svg";
import System from "../../../helper/system";
import Constants from "../../../helper/Constants";
import Helper from "../../../helper/Helper";
import { __remove, __set } from "../../../store/axios_indicator";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import { useDOMAttachToSystemStore } from "src/hooks/domAttachToSystem";
import ShowAlert from "src/component/Global/ShowAlert";

const OrderInsightInfo = () => {
  const [{ orderInsightInfo }, { get_admin_order_insight_info }, { reprocess_order }] = useAdminOrderStore();
  const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();
  const { paymentType } = Constants;
  const [__check] = useAxiosIndicatorCheck();
  const urlParams = System.getParams();

  useEffect(() => {
    async function fetchHere() {
      await get_admin_order_insight_info(urlParams);
    }

    fetchHere();
  }, []);

  const onRefresh = async (e) => {
    __set("ORDER_REPROCESS")
    await get_admin_order_insight_info(urlParams);
    __remove("ORDER_REPROCESS")
  }
  const onReprocess = async (e) => {
    __set("ORDER_REPROCESS")
    const res = await reprocess_order(urlParams);
    __remove("ORDER_REPROCESS")
    if (!res?.isSuccessFull) {
      await system_alert_indicator({
        name: "reprocessOrder",
        message: res?.errorMessage,
        type: "danger",
        isDisplay: true,
      });
    }
    onRefresh()
  }

  return <>
    <div className="container">
      <div className="adminconsole-head header-container d-flex align-items-center justify-content-between">
        <div className="page-title font-oswald font-light font-38 text-green cursor-pointer">Admin Console</div>
      </div>
      <div className="pcn-line-divider"></div>
      <div className="page-title font-oswald font-light font-30 d-flex">ORDER INSIGHTS
        {__check("ORDER_REPROCESS").status ? __check("ORDER_REPROCESS").render :
          <div className="ms-auto">
            <button className="btn btn-secondary bs5 w150" onClick={onRefresh}>REFRESH</button>
            <button className="btn btn-primary bs5 w150 ms-3" disabled={!orderInsightInfo?.isReprocessable} onClick={onReprocess}>reprocess</button>
          </div>}
      </div>
      <div className='bom-alert'>
        <ShowAlert onlyShowMessage={['adminconsole', 'AdminOrderError', 'reprocessOrder']} />
      </div>
    </div>
    <div className="userdetails bg-gray3 order-insite-container">
      <div className="bg-white pt-3 pb-3">
        <div className="container">
          <div className="font-18 font-apecru mb-4">Order Information</div>
          <div className="order-insite-list">
            <div className="font-arial font-13">
              <strong>P.O. Number </strong>
              <p className="mb-0">{orderInsightInfo?.poNumber}</p>
            </div>
            <div className="font-arial font-13">
              <strong>Web Order Number </strong>
              <p className="mb-0">{orderInsightInfo?.webOrderNumber}</p>
            </div>
            <div className="font-arial font-13">
              <strong>Sales Order Number </strong>
              <p className="mb-0">{orderInsightInfo?.salesOrderNumber}</p>
            </div>
            <div className="font-arial font-13">
              <strong>Internal Order State</strong>
              <p className="mb-0">{orderInsightInfo?.fspOrderState}</p>
            </div>
            <div className="font-arial font-13">
              <strong>Reject Reason</strong>
              <p className="mb-0">{orderInsightInfo?.rejectedReason}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-grey2 pt-3 pb-3 order-insite-secondrow">
        <div className="container">
          <div className="order-insite-list">
            <div className="font-arial font-13">
              <div className="d-flex align-items-center font-arial font-16 mb-2">
                <img src={orderinsiteuser} className="me-2" />
                <strong> Buyer Contact Information</strong>
              </div>
              <p className="mb-0 font-arial font-13">
                <div>{orderInsightInfo?.buyerContact?.buyerName} </div>
                <div>{orderInsightInfo?.buyerContact?.buyerEmail}</div>
                <div>{orderInsightInfo?.buyerContact?.buyerTelphoneNumber}</div></p>
            </div>

            <div className="font-arial font-13">
              <div className="d-flex align-items-center font-arial font-16 mb-2">
                <img src={orderinsitebilling} className="me-2" />
                <strong> Billing Address</strong>
              </div>
              <p className="mb-0 font-arial font-13">
                <div>{orderInsightInfo?.billingAddress?.lineOne}</div>
                <div>{orderInsightInfo?.billingAddress?.lineTwo}</div>
                <div>{orderInsightInfo?.billingAddress?.lineThree}</div>
                {orderInsightInfo?.billingAddress?.cityName}, {orderInsightInfo?.billingAddress?.stateName} {orderInsightInfo?.billingAddress?.postalCode}<br />
                {orderInsightInfo?.billingAddress?.countryName}<br />
                {orderInsightInfo?.billingAddress?.countrySubDivisionCode}<br />
              </p>
            </div>

            <div className="font-arial font-13">
              <div className="d-flex align-items-center font-arial font-16 mb-2">
                <img src={orderinsiteshipping} className="me-2" />
                <strong>Shipping Address</strong>
              </div>
              <p className="mb-0 font-arial font-13">
                <div>{orderInsightInfo?.shippingAddress?.lineOne} </div>
                <div>{orderInsightInfo?.shippingAddress?.lineTwo} </div>
                <div>{orderInsightInfo?.shippingAddress?.lineThree} </div>
                {orderInsightInfo?.shippingAddress?.cityName}, {orderInsightInfo?.shippingAddress?.stateName} {orderInsightInfo?.shippingAddress?.postalCode} <br />
                {orderInsightInfo?.shippingAddress?.countryName} <br />
                {orderInsightInfo?.shippingAddress?.countrySubDivisionCode}
              </p>
            </div>

            <div className="font-arial font-13">
              <div className="d-flex align-items-center font-arial font-16 mb-2">
                <img src={orderinsiteshippingmethod} className="me-2" />
                <strong>Shipping Method</strong>
              </div>
              <p className="mb-0 font-arial font-13">
                {orderInsightInfo?.carrierInfo?.carrierKey} <br />
                {orderInsightInfo?.carrierInfo?.carrierService} </p>
            </div>
            <div className="font-arial font-13">
              <div className="d-flex align-items-center font-arial font-16 mb-2">
                <img src={companyIcon} className="me-2" />
                <strong>Company Name</strong>
              </div>
              <p className="mb-0 font-arial font-13">
                {orderInsightInfo?.buyerContact?.companyName} </p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white pt-3 pb-3">
        <div className="container">
          <div className="order-insite-list">
            <div className="font-arial font-13">
              <div className="d-flex align-items-center font-arial font-16 mb-2">
                <strong> Payment Method </strong>
              </div>

              <div className="d-flex">
                <div className="me-4">
                  <div className="font-arial font-13">
                    {orderInsightInfo?.paymentInfo?.paymentType === paymentType.CreditCard && <strong>  Credit Card </strong>}
                    {orderInsightInfo?.paymentInfo?.paymentType === paymentType.AvnetCredit && <strong>  Avnet Credit Line </strong>}
                  </div>
                  <div className="d-flex align-items-center font-arial font-13 mb-3">
                    <span>
                      <span dangerouslySetInnerHTML={{ __html: Helper.getCreditCardDetails(orderInsightInfo?.paymentInfo?.cardType?.toLowerCase())?.icon }} />
                      <span className='font-13 font-arial ms-2'>{Helper.getCreditCardDetails(orderInsightInfo?.paymentInfo?.cardType?.toLowerCase())?.name}</span>
                    </span>
                  </div>
                  <p className="mb-0 font-arial font-13">
                    <strong> Tax Exempt </strong> <br />
                    {orderInsightInfo?.paymentInfo?.taxExempt}</p>
                </div>
                <div>
                  <p className="mb-0 font-arial font-13">
                    <strong> Terms Account<br />Information </strong> <br />
                    {orderInsightInfo?.paymentInfo?.accountNumber}</p>
                </div>
              </div>
            </div>

            <div className="font-arial font-13">
              <div className="d-flex align-items-center font-arial font-16 mb-2">
                <strong> Additional Information </strong>
              </div>
              <p className="mb-0 font-arial font-13">
                <strong> Order Date</strong> <br />
                {Helper.dateFormatFromString(orderInsightInfo?.orderDate)}</p>
            </div>

          </div>
        </div>
      </div>

    </div>

  </>;
}

export default OrderInsightInfo;